import EuropeWidget from './EuropeWidget';

export default EuropeWidget;
